export class TabWatcher {
    constructor() {
        this._map = new Map();
    }
    add(container, watcher) {
        let watchers = this._map.get(container);
        if (!watchers) {
            watchers = [];
            this._map.set(container, watchers);
        }
        watchers.push(watcher);
    }
    remove(container) {
        this._map.delete(container);
    }
    clear() {
        this._map.clear();
    }
    call() {
        this._map.forEach(watchers => {
            for (let i = 0; i < watchers.length; i++) {
                watchers[i]();
            }
        });
    }
}
//# sourceMappingURL=TabWatcher.js.map